/**
 * What the 3B screen may say about 6.1 (W3-18 (1)).
 *
 * When 4(A)'s credit is not established — no 2B, or no purchase register — the service states 6.1
 * instead of working it out: a payment computed on a credit nobody established shows the whole
 * liability as cash. When it IS worked out, the service says whether a balance from the portal's
 * electronic credit ledger was supplied; until that download is read (D-97) none is, and the cash
 * shown may be more than is due.
 */

export type Heads = Record<string, number>

export type Payment =
  | { established: false; says: string }
  | {
      established: true
      noOpeningCredit: boolean
      /** The cell's own sentence: which ledger balances it opened with, as on when (D-97). */
      says: string | null
      /**
       * W3-18 (8): 6.1's cash against the electronic cash ledger's balance. Null when no cash
       * ledger balance was supplied — nobody has said what is there, which is not nil.
       */
      deposit: { fromBalance: Heads; toDeposit: Heads } | null
    }

const NOT_ESTABLISHED =
  'Not worked out: the input credit for this month is not established (see 4(A)).'

export function paymentOf(cell: Record<string, unknown> | undefined): Payment {
  const source = (cell?.source ?? {}) as Record<string, unknown>
  if (typeof cell?.state === 'string') {
    return {
      established: false,
      says: typeof source.says === 'string' ? source.says : NOT_ESTABLISHED,
    }
  }
  const fromBalance = cell?.cash_from_balance as Heads | undefined
  const toDeposit = cell?.cash_to_deposit as Heads | undefined
  return {
    established: true,
    noOpeningCredit: source.opening_credit === 'not_supplied',
    says: typeof source.says === 'string' ? source.says : null,
    deposit: fromBalance && toDeposit ? { fromBalance, toDeposit } : null,
  }
}
